// angular core dependencies
import {
  Component,
  Input,
  Signal,
  WritableSignal,
  computed,
  signal,
} from '@angular/core';

// shared dependencies
import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';

@Component({
  selector: 'fz-card-status',
  templateUrl: './card-status.component.html',
  styleUrls: ['./card-status.component.scss'],
})
export class CardStatusComponent {
  @Input()
  set tournament(t: CasualTournamentEntity) {
    this._tournament = signal(t);
  }

  get tournament() {
    return this._tournament();
  }

  _tournament: WritableSignal<CasualTournamentEntity>;

  /**
   * Represents the state of the card.
   * Possible values are 'Completed', 'Coming Soon', and 'Ended'.
   */
  state: Signal<'Completed' | 'Coming Soon' | 'Active' | 'Ended'> = computed(
    () => {
      const t = this._tournament();
      if (t.isComplete) {
        return 'Completed';
      }

      if (t.comingSoon) {
        return 'Coming Soon';
      }

      if (t.ended) {
        return 'Ended';
      }

      if (!t.lifeExperience) {
        if (t?.casualGameStartTime && t?.casualGameEndTime instanceof Date) {
          if (t?.casualGameStartTime?.getTime() > Date.now())
            return 'Coming Soon';
        }
        if (t?.casualGameStartTime && t?.casualGameEndTime instanceof String) {
          if (new Date(t?.casualGameStartTime).getTime() > Date.now())
            return 'Coming Soon';
        }

        if (t?.casualGameEndTime && t?.casualGameEndTime instanceof Date) {
          if (t?.casualGameEndTime?.getTime() <= Date.now()) {
            return 'Ended';
          }
        }

        if (t?.casualGameEndTime && t?.casualGameEndTime instanceof String) {
          if (new Date(t?.casualGameEndTime)?.getTime() <= Date.now()) {
            return 'Ended';
          }
        }
      }

      return 'Active';
    },
  );

  entryAmount = computed(() => {
    const t = this._tournament();

    if (t.lifeExperience) {
      return t.eventSchedules[0].entryAmount;
    }
    return t?.entryFeeRange?.start;
  });

  cls = computed(() => {
    const t = this._tournament();
    if (t.isComplete) {
      return 'game-card__status__completed';
    }

    if (t.comingSoon) {
      return 'game-card__status__coming-soon';
    }

    if (t.ended) {
      return 'game-card__status__ended';
    }

    return '';
  });
}
